var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30558 11.9716C4.16909 11.8467 4.09242 11.6773 4.09242 11.5007C4.09242 11.3241 4.16909 11.1547 4.30558 11.0298L8.15925 7.50415L4.30558 3.97853C4.23605 3.91708 4.18058 3.84358 4.14242 3.76232C4.10427 3.68105 4.08418 3.59365 4.08334 3.5052C4.0825 3.41676 4.10092 3.32905 4.13753 3.24719C4.17414 3.16533 4.2282 3.09096 4.29656 3.02842C4.36492 2.96588 4.44621 2.91642 4.53569 2.88292C4.62516 2.84943 4.72104 2.83258 4.81771 2.83335C4.91438 2.83412 5.00992 2.85249 5.09874 2.8874C5.18757 2.92231 5.26791 2.97305 5.33507 3.03667L9.70348 7.03323C9.83997 7.15814 9.91665 7.32753 9.91665 7.50415C9.91665 7.68078 9.83997 7.85017 9.70348 7.97508L5.33507 11.9716C5.19854 12.0965 5.01339 12.1667 4.82033 12.1667C4.62727 12.1667 4.44212 12.0965 4.30558 11.9716Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.f4f7169983b601d11f1b54256d81854f.svg";
export { ForwardRef as ReactComponent };